<table class="common-style">
  <tr>
    <th>
      <sc-dictionary-label dictionaryKey="tmc-common.equipment-log.entity.date-handout"></sc-dictionary-label>
    </th>
    <th>
      <sc-dictionary-label dictionaryKey="tmc-common.equipment-log.entity.date-takeback"></sc-dictionary-label>
    </th>
    <th>
      <sc-dictionary-label dictionaryKey="tmc-common.equipment-log.entity.note"></sc-dictionary-label>
    </th>
  </tr>
  @for (equipmentLog of equipmentLogs; track equipmentLog) {
    <tr>
      <td>{{equipmentLog.handOut | timestamp}}</td>
      <td>{{equipmentLog.takeBack | timestamp}}</td>
      <td>{{equipmentLog.note}}</td>
    </tr>
  }
</table>
